import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        const isValid = payload.base_url && payload.endpoint_url;

        if (!isValid) {
            return [];
        }

        const needAuth = payload.auth === true;

        if (needAuth) {
            const appCookieKey = 'tokenCookie';
            const sharedCookieKey = 'AuthToken';

            const jwtFromCookie = getCookieByName(appCookieKey);
            const sharedCookie = getCookieByName(sharedCookieKey);

            if (jwtFromCookie && sharedCookie) {
                const wholeTokenFromCookie = JSON.parse(sharedCookie);

                let spatFromCookie = wholeTokenFromCookie.spat;

                let result = await apiClient(config).apiMethod({
                    method: 'CallExternalEndpointWithAuth',
                    headers: {
                        'X-Auth-Token': jwtFromCookie,
                        'X-Auth-Spat': spatFromCookie,
                    },
                    args: {
                        ...payload,
                    },
                    urlArgs: {
                        base_url: payload.base_url,
                        endpoint_url: payload.endpoint_url,
                    },
                });
                return result;
            } else {
                return [];
            }
        } else {
            let result = await apiClient(config).apiMethod({
                method: 'CallExternalEndpoint',
                headers: {},
                args: {
                    ...payload,
                },
                urlArgs: {
                    base_url: payload.base_url,
                    endpoint_url: payload.endpoint_url,
                },
            });

            return result;
        }
    };
};
